import React from "react";
import { Link } from "react-router-dom";
import "./AboutUs.css"; // <- add this

const AboutUs = () => (
  <div className="row clearfix">
    <div className="col-sm-2"></div>
    <div className="col-sm-9" style={{ padding: 0 }}>
      <div className="container-fluid">

        {/* Header */}
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h2>About iOdin — Proactive Cyber Threat Intelligence</h2>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">About Us</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Mission & Approach */}
        <div className="row clearfix">
          <div className="col-xl-12">
            <div className="card">
              <div className="header">
                <h2>Our Mission</h2>
              </div>
              <div className="body">
                <div className="row">
                  <div className="col-lg-8">
                    <p className="lead">
                      At iOdin — a division of Aeger Group AS — our mission is to provide effortless,
                      proactive cybersecurity by continuously scanning your digital footprint and delivering
                      real-time, actionable intelligence.
                    </p>
                    <p>
                      We combine automated scan platforms with on-demand expert remediation teams.
                      You simply share your domain and context, and we handle the rest — no installation,
                      no setup, just immediate insights and risk reduction. Learn more at{" "}
                      <a
                        href="https://www.iodin.io/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        iodin.io
                      </a>.
                    </p>
                  </div>
                  <div className="col-lg-4">
                    <div className="card border-left-primary">
                      <div className="body text-center">
                        <h4 className="text-primary">Zero Setup</h4>
                        <p className="text-muted">
                          Provide your domain and keywords — our platform delivers insights instantly.
                        </p>
                      </div>
                    </div>
                    <div className="small text-muted mt-2">
                      <i className="fa fa-info-circle mr-1" />
                      We align with industry best practices and privacy regulations to support governance goals.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix equal-row">
          <div className="col-xl-6 col-lg-12 mb-4 mb-xl-0">
            <div className="card">
              <div className="header"><h2>What We Do</h2></div>
              <div className="body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <i className="fa fa-search text-primary mr-3" />
                    <strong>Proactive Surface & Dark Web Scanning</strong><br />
                    <span className="text-muted">Continuous monitoring for exposed assets and emerging threats.</span>
                  </li>
                  <li className="mb-3">
                    <i className="fa fa-bolt text-primary mr-3" />
                    <strong>Real-Time Alerts & Threat Detection</strong><br />
                    <span className="text-muted">Automated detection with instant, actionable reporting.</span>
                  </li>
                  <li className="mb-3">
                    <i className="fa fa-shield text-primary mr-3" />
                    <strong>Risk Prioritization & Vulnerability Discovery</strong><br />
                    <span className="text-muted">Focus on the issues most likely to be exploited.</span>
                  </li>
                  <li className="mb-3">
                    <i className="fa fa-wrench text-primary mr-3" />
                    <strong>VAPT & Remediation Support</strong><br />
                    <span className="text-muted">On-demand experts to help fix critical issues fast.</span>
                  </li>
                  <li className="mb-3">
                    <i className="fa fa-file-text-o text-primary mr-3" />
                    <strong>Compliance Reporting & Dashboards</strong><br />
                    <span className="text-muted">Clear insights and audit-ready reports for governance.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-xl-6 col-lg-12">
            <div className="card">
              <div className="header"><h2>Why Choose iOdin</h2></div>
              <div className="body">
                <div className="mb-4">
                  <h6 className="text-primary">🚀 Fast &amp; Frictionless</h6>
                  <p className="text-muted small mb-0">No installs or long deployments — start protecting in hours.</p>
                </div>
                <div className="mb-4">
                  <h6 className="text-primary">🌐 Broad Visibility</h6>
                  <p className="text-muted small mb-0">From surface to dark web — see threats before they see you.</p>
                </div>
                <div className="mb-4">
                  <h6 className="text-primary">👥 Expertise on Demand</h6>
                  <p className="text-muted small mb-0">Guidance through detection, prioritization, and remediation.</p>
                </div>
                <div>
                  <h6 className="text-primary">📈 Compliance-Friendly</h6>
                  <p className="text-muted small mb-0">Audit-ready dashboards and reports for your regulatory needs.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Story */}
        <div className="row clearfix">
          <div className="col-xl-12">
            <div className="card">
              <div className="header">
                <h2>Our Story</h2>
              </div>
              <div className="body">
                <div className="row">
                  <div className="col-lg-8">
                    <p>
                      We started with a simple observation: most security programs were built for the
                      inside of the network, while attackers exploit what’s visible from the outside.
                      Shadow assets, misconfigurations, and brand impersonation expose organizations
                      long before an incident is detected.
                    </p>
                    <p>
                      iOdin closes that gap. We help teams of all sizes gain continuous visibility over
                      their external footprint, respond to issues quickly, and build long-term resilience.
                    </p>
                  </div>
                  <div className="col-lg-4">
                    <div className="card bg-light">
                      <div className="body">
                        <h6 className="text-center mb-3">Our Values</h6>
                        <ul className="list-unstyled small mb-0">
                          <li className="mb-2">
                            <i className="fa fa-check text-success mr-2" />
                            <strong>Trust:</strong> Transparent, no-nonsense security advice
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check text-success mr-2" />
                            <strong>Expertise:</strong> Continuous learning and practical excellence
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check text-success mr-2" />
                            <strong>Vigilance:</strong> Proactive monitoring and fast action
                          </li>
                          <li>
                            <i className="fa fa-check text-success mr-2" />
                            <strong>Integrity:</strong> Do the right thing, every time
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>

        {/* Impact metrics */}
        <div className="row clearfix">
          <div className="col-xl-4 col-lg-4 col-md-12">
            <div className="card text-center">
              <div className="body">
                <h3 className="text-primary">24/7</h3>
                <p className="text-muted mb-0">Continuous Monitoring</p>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12">
            <div className="card text-center">
              <div className="body">
                <h3 className="text-success">Minutes</h3>
                <p className="text-muted mb-0">From Alert to Action</p>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12">
            <div className="card text-center">
              <div className="body">
                <h3 className="text-info">Zero Fluff</h3>
                <p className="text-muted mb-0">Clear, Prioritized Fixes</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="row clearfix">
          <div className="col-xl-12">
            <div className="card">
              <div className="header"><h2>Ready to Secure Your External Threat Surface?</h2></div>
              <div className="body text-center">
                <p className="lead">
                  Get proactive. Get protected. Let iOdin safeguard your digital presence — effortlessly.
                </p>
                <Link to="/services" className="btn btn-primary btn-round mr-3">Our Services</Link>
                <Link to="/contact" className="btn btn-outline-primary btn-round">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
);

export default AboutUs;
